<template>
    <div class="t_center">
        <p>未做认证</p>
        <img src="https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=238191277,1480068782&fm=11&gp=0.jpg" alt="">
        <p>打开手机微信，扫一扫</p>
        <div class="t_center">
            <el-button type="primary" @click="next">下一步</el-button>
        </div>
        <!-- 实名认证步骤等具体实现方式出来再写样式 -->
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    data() {
        return {
        }
    },
    methods: {
        next(){
            this.$router.push({name:'SignRegister',query:{step:2}});
        }
    },
}
</script>
<style lang='scss' scoped></style>